// Shared style maps for AdminMerchants UI sub-components.
export const STATUS_STYLES = {
  pending: { bg: 'bg-amber-500/10', text: 'text-amber-400', border: 'border-amber-500/20', label: 'Pending Review' },
  approved: { bg: 'bg-[#00E676]/10', text: 'text-[#00E676]', border: 'border-[#00E676]/20', label: 'Approved' },
  rejected: { bg: 'bg-[#FF1744]/10', text: 'text-[#FF1744]', border: 'border-[#FF1744]/20', label: 'Rejected' },
};

export const BUSINESS_TYPES = {
  food: 'Food & Beverage', retail: 'Retail & Shopping', health: 'Health & Wellness',
  beauty: 'Beauty & Salon', tech: 'Technology & IT', travel: 'Travel & Tourism',
  education: 'Education & Training', entertainment: 'Entertainment', automotive: 'Automotive',
  real_estate: 'Real Estate', professional: 'Professional Services', other: 'Other',
};

export const FILTER_ACTIVE_STYLES = {
  amber: 'bg-amber-500/20 text-amber-400 border border-amber-500/30',
  emerald: 'bg-[#00E676]/20 text-[#00E676] border border-[#00E676]/30',
  red: 'bg-[#FF1744]/20 text-[#FF1744] border border-[#FF1744]/30',
  blue: 'bg-[#00E5FF]/20 text-[#00E5FF] border border-[#00E5FF]/30',
};

export const FILTER_INACTIVE = 'bg-white/5 text-[#A0B4CC] border border-white/10 hover:bg-white/10';
